import React from 'react';
import { login } from 'actions/authentication'
import { connect } from 'react-redux';
import { Link } from 'react-router';

class Login extends React.Component {

  constructor() {
    super();
    this.submit = this.submit.bind(this);
    this.displayName = 'Login-Page'
    this.state = { username: '', password: '' }
  }

  handleChange(e) {
    let key = e.target.id;
    let value = e.target.value;
    this.setState({ [key]: value });
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.submit();
    }
  }

  render() {
    return (
      <div className="authentication-wrapper">
        <div className="authentication__card box--shadow bg--white text--center">
          <Link to="/">
            <img src="/src/assets/icons/senzolive-software-logo.svg" className="authentication__card__logo" />
          </Link>
          <h2 className="authentication__card__welcome-message">Welcome to your dashboard</h2>
          <div className="authentication__card__form-wrapper">
            <form action="#">
              <input type="username" id="username" placeholder="Username" onKeyDown={this.handleKeyDown.bind(this)} onChange={this.handleChange.bind(this)} required />
              <input type="password" placeholder="Password" id="password" onKeyDown={this.handleKeyDown.bind(this)} onChange={this.handleChange.bind(this)} required />
              <br />
              <input className="btn-small form__login-btn" type="button" name="user_submit" value="Log in" onClick={this.submit} />
              {<div className='red-500' >{this.props.auth.errorMessage}</div>}
              <div className='forgot-password'>
                <Link to='/forgot'> Forgot your password?</Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }

  submit() {
    this.props.dispatch(login(this.state));
  }
}

function mapStateToProps(state) {
  return {
    auth: state.authReducer
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/login.jsx